import { Signal } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { Subject } from 'rxjs';

export const adjustPageIfNeeded = <T>(
  source: Signal<T[]>,
  { paginator, trigger }: { paginator: MatPaginator; trigger: Subject<void> }
) => {
  const isLastItem = source().length === 1;
  const isFirstPage = paginator.pageIndex === 0;

  if (!isLastItem || isFirstPage) {
    trigger.next();

    return;
  }

  paginator.previousPage();
};
